import request from '@/utils/request'

// var base_url2 = CONFIG.baseUrl2
// if(base_url.indexOf('https:') == 0 && document.location.protocol != 'https:' && location.href.indexOf('//127.0.0.1') == -1 && location.href.indexOf('//localhost') == -1 && location.href.indexOf('//192.') == -1 && location.href.indexOf('//10.') == -1)
// {
//   base_url =  location.replace('https://'+location.href.substring(7));
// }

// export const serve = data => {
//   return request({
//     method: 'POST',
//     url:`acsservices.php`, //${base_url}open/enterprise/services.php`,
//     data
//   })
// }

// export const http = data => {
//   return request({
//     method: 'POST',
//     url:`email/email.php`, 
//     data
//   })
// }

export const serve = data => {
  return request({
    method: 'POST',
    url:`open/test/wx_services.php`,
    // url:`open/enterprise_test/services.php`,
    // url:`open/enterprise/wx_services.php`, //${base_url}open/enterprise/services.php`,
    data
  })
}

export const http = data => {
  return request({
    method: 'POST',
    url:`open/enterprise/services.php`, //${base_url}open/enterprise/services.php`,
    data
  })
}

export const emails = data => {
  return request({
    method: 'POST',
    url:`open/email/email.php`, //${base_url}open/enterprise/services.php`,
    data
  })
}

export const server = data => {
  return request({
    method: 'POST',
    url:`open/test/wx_services.php`, //${base_url}open/enterprise/services.php`,
    data
  })
}

export const server2 = data => {
  return request({
    method: 'POST',
    url:`open/enterprise_test/services.php`, //${base_url}open/enterprise/services.php`,
    data
  })
}





